import React from 'react';
import { Link } from 'react-router-dom';

const sampleProducts = [
  { name: 'Classic Coxinha', price: 6.5 },
  { name: 'Catupiry Coxinha', price: 6.5 },
  { name: 'Brigadeiro', price: 1.8 },
  { name: 'Mini Carrot Cake', price: 5.5 },
];

export default function Products() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Products</h2>
      <p>Sample product list used by the Order page.</p>
      <ul>
        {sampleProducts.map(p => (
          <li key={p.name} style={{ margin: '8px 0' }}>
            <strong>{p.name}</strong> — CAD$ {p.price.toFixed(2)}
          </li>
        ))}
      </ul>
      <p>
        Want to place an order? <Link to="/order-now">Go to Order Now</Link>
      </p>
    </div>
  );
}
